import React from 'react'

// Component ----

function CardSkeleton() {
  return (
    <div className="flex animate-pulse gap-4 h-full w-full rounded-md border border-gray-200 min-h-[4.5rem] pr-4">
      <div className='self-stretch w-[60px] sm:w-[100px] bg-gray-200 overflow-hidden flex-shrink-0' />
      <div className="flex flex-col flex-grow gap-4 justify-center">
        <div className="h-2 rounded-full bg-gray-200 max-w-[80%]"></div>
        <div className="h-2 rounded-full bg-gray-200 max-w-[40%]"></div>
      </div>
    </div>
  );
}

export {CardSkeleton};